// @owners { team: patient-health }
import { BORDERS } from '@alto/design-library-tokens';
// eslint-disable-next-line @alto/no-pocky-import
import { Button, FlexColumn, FlexRow, H3, Text, palette, spacing } from '@alto/pocky';
import autobind from 'autobind-decorator';
import React from 'react';
import styled from 'styled-components';
import { type ModalType } from '~shared/actions/modal';

type Props = {
  readonly openModal: (arg0: ModalType) => void;
  readonly updateCashPay: () => void;
};

const NeedsInsuranceContainer = styled(FlexRow)`
  padding: ${spacing.smSpacing};
  border: ${BORDERS.SIZE}px solid ${palette.grey2};
  background-color: ${palette.altoColorsW};
`;

export default class NeedsInsurance extends React.PureComponent<Props> {
  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  handleAddInsurance() {
    const { openModal } = this.props;
    openModal('INSURANCE_MODAL');
  }

  render() {
    const { updateCashPay } = this.props;
    return (
      <NeedsInsuranceContainer spacing={spacing.smSpacing}>
        <H3>Add Insurance Information</H3>
        <Text>
          Add your insurance information so we can find the best price for your medication and get it ready for you to
          schedule a delivery.
        </Text>
        <FlexColumn spacing={spacing.xsSpacing}>
          {/* eslint-disable-next-line @typescript-eslint/unbound-method */}
          <Button onClick={this.handleAddInsurance}>Add Insurance Card</Button>
          <Button
            onClick={updateCashPay}
            kind="secondary"
          >
            I Don’t Have Insurance
          </Button>
        </FlexColumn>
      </NeedsInsuranceContainer>
    );
  }
}
